import { Box, ListItem, ListItemIcon } from "@mui/material";
import IconButton from "@mui/material/IconButton";
import Menu from "@mui/material/Menu";
import { ReactComponent as ArrowDown } from "assets/ArrowDown.svg";
import DeleteCircle from "assets/DeleteCircle";
import { ReactComponent as SmallDrop } from "assets/SmallDrop.svg";
import { uniqueId } from "lodash";
import * as React from "react";
import { tokens } from "styles/Tokens";
import { getUserNameWithConditionalCheck } from "utils/SharedUtils";
import Typography from "../Typography";

interface Props {
  options?: any;
  handleChange: (option: any, i?: any) => void;
  sx?: any;
  transformOrigin?: any;
  isPlan?: boolean;
  label?: any;
  allFilters?: any;
}

export default function ScrollableList(props: Props) {
  const { options, handleChange, isPlan = true, label = null, allFilters } = props;
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const open = Boolean(anchorEl);

  const handleClick = (event: React.MouseEvent<HTMLElement>) => {
    if (options.length) setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  React.useEffect(() => {
    if (!options.length) {
      setAnchorEl(null);
    }
  }, [options]);

  const getValueByKey = (key: string, filter: any) => {
    const entry = filter?.find((entry: any) => entry?.key === key);
    return entry ? entry?.value : key;
  };

  return (
    <Box>
      <>
        {isPlan ? (
          <IconButton
            disableRipple
            aria-label="more"
            id="long-button"
            aria-controls={open ? "long-menu" : undefined}
            aria-expanded={open ? "true" : undefined}
            aria-haspopup="true"
            onClick={handleClick}
          >
            <ArrowDown />
          </IconButton>
        ) : (
          <div onClick={handleClick} className="select-title">
            {label}
            {open ? <SmallDrop /> : <ArrowDown />}
          </div>
        )}
      </>
      <Menu
        MenuListProps={{
          "aria-labelledby": "long-button"
        }}
        anchorEl={anchorEl}
        transformOrigin={{
          vertical: "top",
          horizontal: "right"
        }}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "right"
        }}
        open={open}
        onClose={handleClose}
        PaperProps={{
          sx: {
            width: "357px",
            marginY: "8px",
            borderRadius: "8px",
            maxHeight: "240px",
            overflowY: "auto",
            color: tokens.Text.General.PrimaryBody,
            fontVariant: "body2"
          }
        }}
      >
        {options?.map((option: any, index: number) => {
          const filterByName = allFilters?.filter((filter: any) => filter.name === option.name);
          const selectedFilters = filterByName && filterByName[0]?.filters;
          const name = getValueByKey(option.option, selectedFilters);

          return isPlan ? (
            <ListItem key={uniqueId("OPTION_")} alignItems="center">
              {" "}
              <Typography sx={{ width: "268px", wordWrap: "wrap" }}>
                {option?.innCodes?.length &&
                  option.innCodes.map((code: string, i: number) => {
                    return (
                      <>
                        <strong className="m-r-8">{code}</strong>{" "}
                      </>
                    );
                  })}{" "}
                {option?.name
                  ? option.name
                  : getUserNameWithConditionalCheck(option?.displayName, option?.firstName, option?.lastName)}
              </Typography>
              <ListItemIcon
                onClick={() => handleChange(option, index)}
                sx={{ display: "flex", justifyContent: "flex-end", cursor: "pointer" }}
              >
                <DeleteCircle color={tokens.Border.General.Secondary} />
              </ListItemIcon>
            </ListItem>
          ) : (
            <div style={{ padding: "8px 16px" }}>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <Typography variant="body2" showBold color="#3E3A39" className="ellipse-one">
                  {name}
                </Typography>
                <div onClick={() => handleChange(option, index)}>
                  <DeleteCircle color={tokens.Border.General.Secondary} />
                </div>{" "}
              </div>
              <Typography variant="label">{option.name}</Typography>
            </div>
          );
        })}
      </Menu>
    </Box>
  );
}
